import { CrudService } from '@/services/crudService';

const RESOURCE_URL = `/cztextblocks`;
const crud = new CrudService({ allowAuth: false, handleUnauthorized: false });

export const blogService = {
  async getPopularPosts() {
    try {
      const response = await crud.httpGet(`${RESOURCE_URL}/list-with-users?count=3&popular=false`);
      return Array.isArray(response) ? response : [];
    } catch {
      return [];
    }
  },

  async getPostsByPage(startRow: number, endRow: number) {
    try {
      const gridStatus = {
        filters: { TextBlockType: { type: 'equals', filter: 0, filterType: 'number' } },
        sort: [{ colId: 'Created', sort: 'desc' }]
      };
      const encodedGridStatus = encodeURIComponent(JSON.stringify(gridStatus));
      const response = await crud.httpGet(`${RESOURCE_URL}/list-by-page?startRow=${startRow}&endRow=${endRow}&gridStatus=${encodedGridStatus}`);
      return response;
    } catch {
      return {
        ok: false,
        totalCount: 0,
        data: [],
      };
    }
  },

  async getPostById(id: string | number) {
    try {
      const response = await crud.httpGet(`${RESOURCE_URL}/get-with-user?id=${id}`);
      return response;
    } catch {
      return null;
    }
  }
};
